//import { ConciergeSearch, ConciergePut, ConciergePost } from '../interfaces/Concierge'
import { getUrlInvoiceApi } from '../utils/util';
import ApiHandler from './ApiHandler';

export const baseURL = String(getUrlInvoiceApi(window));

export default class InvoiceApi {
    static async get(invoiceKey: string, onlyCache: boolean = false) {
        // var response = await ApiHandler(baseURL).get(`invoice/getcache/${invoiceKey}&onlyCache=${onlyCache}`);
        var response = await ApiHandler(baseURL).post(`invoice/searchwithkeynumbers`, { InvoiceKeyNumbers: [ invoiceKey] });
        return response?.data;
    }
}
